<template>
  <tr>
    <td class="text-xs-left text-no-wrap">
      <router-link
        :to="{
          name: 'single-discount',
          params: { id: props.item.id }
        }"
        class="text-no-wrap"
      >
        {{ props.item.name }}
      </router-link>
    </td>
    <td class="text-xs-left">
      {{ props.item.type }}
    </td>
    <td class="text-xs-left">
      <v-chip
        color="primary"
        label
        small
        dark
      >
        {{ props.item.active ? $t('Active') : $t('Disabled') }}
      </v-chip>
    </td>
    <td class="text-xs-left">
      {{ props.item.code }}
    </td>
    <td class="text-xs-left">
      {{ props.item.start_date | timezone }}
    </td>
    <td class="text-xs-left">
      {{ props.item.end_date | timezone }}
    </td>
  </tr>
</template>
<script>
export default {
  name: 'CustomerDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
